import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { QualifierValue } from './QualifierValue.js';
import { QualifierModel } from '../models/QualifierModel.js';
/**
 * @summary SDK
 * @memberOf SDK
 */
var Qualifier = /*#__PURE__*/function (_QualifierModel) {
  function Qualifier(key, qualifierValue) {
    var _this;
    _classCallCheck(this, Qualifier);
    _this = _callSuper(this, Qualifier);
    _this.delimiter = '_'; // {key}{delimiter}{qualifierValue}
    _this.key = key;
    if (qualifierValue instanceof QualifierValue) {
      _this.qualifierValue = qualifierValue;
    } else {
      _this.qualifierValue = new QualifierValue();
      _this.qualifierValue.addValue(qualifierValue);
    }
    return _this;
  }
  _inherits(Qualifier, _QualifierModel);
  return _createClass(Qualifier, [{
    key: "toString",
    value: function toString() {
      var key = this.key,
        delimiter = this.delimiter,
        qualifierValue = this.qualifierValue;
      return "".concat(key).concat(delimiter).concat(qualifierValue.toString());
    }
  }, {
    key: "addValue",
    value: function addValue(value) {
      this.qualifierValue.addValue(value);
      return this;
    }
  }]);
}(QualifierModel);
export { Qualifier };